import { monteurApi } from '../common/monteur-api';
export var microsoftVisionApi = monteurApi.injectEndpoints({
    endpoints: function (builder) { return ({
        analyzeImage: builder.mutation({
            query: function (_a) {
                var imageData = _a.imageData, readingOrder = _a.readingOrder;
                var readingOrderParam = readingOrder
                    ? "?readingOrder=".concat(encodeURIComponent(readingOrder))
                    : '';
                return {
                    url: "Vision/read/analyze".concat(readingOrderParam),
                    method: 'POST',
                    body: imageData
                };
            },
            transformResponse: function (response) { var _a; return (_a = response.operationId) !== null && _a !== void 0 ? _a : ''; }
        }),
        fetchOcrResult: builder.query({
            keepUnusedDataFor: 0,
            query: function (operationId) { return ({
                url: "Vision/read/results/".concat(operationId),
                method: 'GET'
            }); },
            transformResponse: function (response) {
                var _a;
                if (response.status !== 'succeeded')
                    return response.status;
                return (_a = response.text) !== null && _a !== void 0 ? _a : '';
            }
        })
    }); }
});
export var useAnalyzeImageMutation = microsoftVisionApi.useAnalyzeImageMutation, useLazyFetchOcrResultQuery = microsoftVisionApi.useLazyFetchOcrResultQuery;
